module.exports = __webpack_public_path__ + "static/media/home-stock-05.4c03fecc.png";